<template>
    <div class="dd-l-section--video__thumb" v-if="item">
        <picture class="dd-l-section--video__img">
            <source :srcset="item.image.desktop" media="(min-width: 1280px)">
            <source :srcset="item.image.tablet" media="(min-width: 768px)">
            <img :srcset="item.image.mobile" :alt="item.title">
        </picture>

        <button type="button" class="dd-l-section--video__btn-play" v-on:click="show(item.video)">
            <i class="dd-m-icon icon-play"></i>
        </button>
    </div>
</template>
<script>
    export default {
        name: 'card-video',
        props: ['item', 'show'],
        mounted() {
        },
        computed: {
            player() {
                return this.$refs.plyr.player
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-video.vue